import { render, staticRenderFns } from "./AdvertisingModalAdvancedConfigCaptiveFormsFilterTable.vue?vue&type=template&id=70045e7a&scoped=true"
import script from "./AdvertisingModalAdvancedConfigCaptiveFormsFilterTable.vue?vue&type=script&lang=js"
export * from "./AdvertisingModalAdvancedConfigCaptiveFormsFilterTable.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingModalAdvancedConfigCaptiveFormsFilterTable.vue?vue&type=style&index=0&id=70045e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70045e7a",
  null
  
)

export default component.exports